export default __webpack_public_path__ + "static/media/portfolioImg_2.d47b12b6.png";